import Amex from './Amex.vue';
import Diners from './Diners.vue';
import Discover from './Discover.vue';
import Jcb from './Jcb.vue';
import Maestro from './Maestro.vue';
import Mastercard from './Mastercard.vue';
import Unipay from './Unipay.vue';
import Visa from './Visa.vue';


export {
    Amex,
    Diners,
    Discover,
    Jcb,
    Maestro,
    Mastercard,
    Unipay,
    Visa
};
